import * as React from "react";
import { useContext } from "react";
import { EditProjectContext } from "../../../EditProjectContext";
import { updateRoutePropertyOnProject } from "./UpdateRoutePropertyOnProject";
import { isProjectReadOnly } from "../../../IsProjectReadOnly";
import { DropDownList } from "../../../../../Layout/Inputs/DropDownList";
import { RouteNumberAreaInputProps } from "./RouteNumberAreaInputProps";

export const SharedClosedLoop = ({ route, disabled = false }: RouteNumberAreaInputProps) => {
  const projectContextProps = useContext(EditProjectContext);
  const { project } = projectContextProps;

  const list = [
    { text: "Yes", value: true },
    { text: "No", value: false },
  ];

  return (
    <DropDownList
      label="Shared Closed Loop"
      list={list}
      value={route.IsSharedClosedLoop}
      onChange={(value) => {
        updateRoutePropertyOnProject(
          "IsSharedClosedLoop",
          value,
          route.RouteNumber || "",
          projectContextProps
        );
      }}
      disabled={isProjectReadOnly(project) || disabled}
    />
  );
};
